import swal from 'sweetalert2'
import Vue from 'vue'
import $ from 'jquery'
const LoginApi = {
  data: {
    urlLogin: '/Login.php',
    urlLoginCRS: '/Login.php',
    urlRegister: '/register'
  },
  doLoginForCRS (postData, onLoginSuccess, onLoginFailed) {
    var cmp = this
    Vue.prototype.$api.showIdle()
    $.post(Vue.config.host + this.data.urlLoginCRS, JSON.stringify(postData), function (data) {
      Vue.prototype.$api.hideIdle()
      Vue.prototype.$api.debug(data)
      if (!data.accessGranted) {
        var credentials = {
          'authorized': false,
          'authToken': null,
          'moduleList': [],
          'productList': [],
          'user': data.user,
          'data': data
        }
        Vue.prototype.$api.setCredentials(credentials)
        if (onLoginFailed) {
          onLoginFailed(data)
        }
        /*
        var titleErrorDialog = 'Fehler bei der Anmeldung'
        var textErrorDialog = '' + data.message
        swal(titleErrorDialog, textErrorDialog, 'error')

         */
        return false
      } else {
        if (onLoginSuccess) {
          onLoginSuccess(data)
        }
        return true
      }
    })
        .catch(function (error, a, b, c) {
          Vue.prototype.$api.hideIdle()
          Vue.prototype.$api.debug(error, a, b, c)
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            Vue.prototype.$api.debug(error.response.data)
            Vue.prototype.$api.debug(error.response.status)
            Vue.prototype.$api.debug(error.response.headers)
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            Vue.prototype.$api.debug(error.request)
          } else {
            // Something happened in setting up the request that triggered an Error
            Vue.prototype.$api.debug('Error', error.message)
          }
          swal(
              'Fehler ' + error.status,
              error.message,
              'error'
          )
          if (onLoginFailed) {
            onLoginFailed()
          }
        })
  },
  doLogin (postData, onLoginSuccess, onLoginFailed) {
    var cmp = this
    Vue.prototype.$api.showIdle()
    $.post(Vue.config.host + this.data.urlLogin, postData, function (data) {
      Vue.prototype.$api.hideIdle()
      Vue.prototype.$api.debug(data)
      if (!data) {
        var credentials = {
          'authorized': false,
          'authToken': null,
          'moduleList': [],
          'productList': [],
          'user': "unknown",
          'data': {}
        }
        Vue.prototype.$api.setCredentials(credentials)
        if (onLoginFailed) {
          onLoginFailed(data)
        }
        return false
      }
      if (data.accessGranted !==1) {
        var credentials = {
          'authorized': false,
          'authToken': null,
          'moduleList': [],
          'productList': [],
          'user': data.user,
          'data': data
        }
        Vue.prototype.$api.setCredentials(credentials)
        if (onLoginFailed) {
          onLoginFailed(credentials)
        }
        return false
      } else {
        if (onLoginSuccess) {
          onLoginSuccess(data)
        }
        return true
      }
    })
      .catch(function (error, a, b, c) {
        Vue.prototype.$api.hideIdle()
        var credentials = {
          'authorized': false,
          'authToken': null,
          'moduleList': [],
          'productList': [],
          'user': "unknown",
          'data': {},
          'accessGranted': 3
        }
        Vue.prototype.$api.setCredentials(credentials)
        if (onLoginFailed) {
          if (error.responseText && error.responseText !== "null") {
            onLoginFailed(JSON.parse(error.responseText))
          } else {
            onLoginFailed(credentials)
          }

        }
      })
  },
  onLoginOk (data, onDone) {
    var cmp = this
    this.onDoneFn = onDone
    var credentials = {
      'authorized': true,
      'authToken': data.authToken,
      'moduleList': data.moduleList,
      'productList': data.productList,
      'user': data.username,
      'data': data
    }

    Vue.prototype.$api.setCredentials(credentials)
    $.ajaxSetup({
      headers: {
        'X-Auth-Token': data.authToken
      }
    })

    if (window.jQuery) {
      window.jQuery.ajaxSetup({
        headers: {
          'X-Auth-Token': data.authToken
        }
      })
    }
    if (window.$) {
      window.$.ajaxSetup({
        headers: {
          'X-Auth-Token': data.authToken
        }
      })
    }

    Vue.prototype.$api.getConfiguration('250', function (data) {
      Vue.prototype.$eventHub.$emit('OnLogin', true)
      cmp.onDoneFn()
    })
  }
}
export default LoginApi



// WEBPACK FOOTER //
// ./src/components/Login/Login.js